<template>
  <div class="sn-f-col-b-s confirm">
    <sn-breadcrumb :breadcrumb="[{
      title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
      replace: true,
      router: $sn.getConfig('pcEntranceArea') ? '/appointment/area' : '/appointment/depart',
    }, {
      title: '选择号源',
      replace: true,
      router: '/appointment/doctor'
    }, {
      title: '确认预约'
    }]"></sn-breadcrumb>
    <div class="sn-f-1 sn-f-col-b-c confirm-region">
      <div class="sn-f-1 entire">
        <div class="sn-f-b-e sn-title">
          <div class="sn-f-c-c title-caption">医生信息</div>
        </div>
        <div class="sn-f-b-c doctor">
          <sn-head-photo :src="doctorInfo.doctorPicture" :width="120" :height="160"></sn-head-photo>
          <div class="sn-f-1 sn-f-col-b-s doctor-info">
            <div class="sn-f-s-c">
              <div class="sn-fs-32 sn-fw-bold">{{ doctorInfo.doctorName }}</div>
              <div class="sn-f-col-c-s doctor-sub" v-if="doctorInfo.deptName || appointment_mixin_formatRecordDoctorTitle(doctorInfo)">
                <div v-if="doctorInfo.deptName">{{ doctorInfo.deptName }}</div>
                <div v-if="appointment_mixin_formatRecordDoctorTitle(doctorInfo)">{{ appointment_mixin_formatRecordDoctorTitle(doctorInfo) }}</div>
              </div>
            </div>
            <div class="sn-f-1 doctor-caption">
              <div>医生介绍：&nbsp;&nbsp;{{ doctorInfo.doctorIntroduce || '暂无' }}</div>
              <div>医生擅长：&nbsp;&nbsp;{{ doctorInfo.doctorSkill || '暂无' }}</div>
            </div>
          </div>
        </div>
        <div class="sn-f-b-e sn-title">
          <div class="sn-f-c-c title-caption">预约信息</div>
        </div>
        <div class="record">
          <div class="sn-f-s-c record-line sn-fc-red1" v-if="isShowScheduleCostAppointment && parseFloat(scheduleInfo.regFee) > 0">
            <div>挂号费用：</div>
            <div>¥{{ scheduleInfo.regFee }}</div>
          </div>
          <div class="sn-f-s-c record-line" v-if="$sn.format.getQuality(separateCaption, 'AREA.' + doctorInfo.deptId)">
            <div>就诊院区：</div>
            <div>{{ $sn.format.getQuality(separateCaption, 'AREA.' + doctorInfo.deptId) }}</div>
          </div>
          <div class="sn-f-s-c record-line">
            <div>就诊地点：</div>
            <div>
              <template  v-if="$sn.format.getQuality(separateCaption, 'ADDRESS.' + doctorInfo.deptId + '.TITLE')">
                {{ $sn.format.getQuality(separateCaption, 'ADDRESS.' + doctorInfo.deptId + '.TITLE') }}
                <template v-if="$sn.format.getQuality(separateCaption, 'ADDRESS.' + doctorInfo.deptId + '.SUB')">
                  &nbsp;-&nbsp;{{ $sn.format.getQuality(separateCaption, 'ADDRESS.' + doctorInfo.deptId + '.SUB') }}
                </template>
              </template>
              <template v-else>
                {{ $sn.utils.getHospitalTitle() }}
                <span class="sn-fc-main" v-if="isHosArea && appointment_mixin_formatAreaCaption(scheduleInfo)">[{{ appointment_mixin_formatAreaCaption(scheduleInfo) }}]</span>
                <template v-if="appointment_mixin_formatAreaCaption(scheduleInfo, 'address')">
                  &nbsp;-&nbsp;{{ appointment_mixin_formatAreaCaption(scheduleInfo, 'address') }}
                </template>
              </template>
            </div>
          </div>
          <div class="sn-f-s-c record-line" v-if="scheduleInfo.scheduleAddress">
            <div>科室地址：</div>
            <div>{{ identifyPolyScheduleRegionLogic &&
            scheduleInfo.scheduleAddress.split(identifyPolyScheduleRegionLogic) && scheduleInfo.scheduleAddress.split(identifyPolyScheduleRegionLogic).length > 0 ?
            scheduleInfo.scheduleAddress.split(identifyPolyScheduleRegionLogic)[0] : scheduleInfo.scheduleAddress }}</div>
          </div>
          <div class="sn-f-s-c record-line">
            <div>{{ $sn.getConfig('appointmentTimeContent') }}：</div>
            <div>
              {{ scheduleInfo.scheduleDate + '（周' +  $sn.format.day(scheduleInfo.scheduleDate) + '）'}}
              <template v-if="$sn.getConfig('isScheduleTimeSerialPostPosition')">
                {{ scheduleTimeInfo.startTime ? scheduleTimeInfo.startTime.substring(0, 5) : '' }}
                <template v-if="scheduleTimeInfo.endTime">-{{ scheduleTimeInfo.endTime.substring(0, 5) }}</template>
                <template v-if="isShowScheduleTimeSeq === 1 || (isShowScheduleTimeSeq === 2 && scheduleTimeInfo.seq && scheduleTimeInfo.seq > 0)">
                  [{{ scheduleTimeInfo.seq }}]
                </template>
              </template>
              <template v-else>
                <template v-if="isShowScheduleTimeSeq === 1 || (isShowScheduleTimeSeq === 2 && scheduleTimeInfo.seq && scheduleTimeInfo.seq > 0)">
                  <span class="sn-fw-bold">{{ scheduleTimeInfo.seq }}</span>[
                </template>
                {{ scheduleTimeInfo.startTime ? scheduleTimeInfo.startTime.substring(0, 5) : '' }}
                <template v-if="scheduleTimeInfo.endTime">-{{ scheduleTimeInfo.endTime.substring(0, 5) }}</template>
                <template v-if="isShowScheduleTimeSeq === 1 || (isShowScheduleTimeSeq === 2 && scheduleTimeInfo.seq && scheduleTimeInfo.seq > 0)">]</template>
              </template>
            </div>
            <div class="sn-f-c-c sn-pointer operate" @click="navigateUrl('/appointment/doctor', '', {}, 'replace');">
              <div class="iconfont icon-qiehuan"></div>
              <div>切换</div>
            </div>
          </div>
          <div class="sn-f-s-c record-line">
            <div>剩余号源：</div>
            <div>{{ scheduleInfo.surplusNumber }}</div>
          </div>
          <div class="sn-f-s-c record-line">
            <div><span style="letter-spacing: 0.5em;">就诊</span>人：</div>
            <template v-if="!$sn.validate.array(patientList)">
              <div>暂未获取到就诊人</div>
              <div class="sn-f-c-c sn-pointer operate" @click="handlePatientInfo();">
                <div class="iconfont icon-shuaxin"></div>
                <div>刷新</div>
              </div>
            </template>
            <template v-else-if="patientList.length === 0">
              <div>暂无就诊人</div>
              <div class="sn-f-c-c sn-pointer operate" @click="navigateUrl('addition-patient');">
                <div class="iconfont icon-zengjiajiuzhenren"></div>
                <div>添加</div>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="sendBackPatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientList"></el-option>
              </el-select>
              <div class="sn-f-c-c sn-pointer operate" v-if="patientList.length < $sn.getConfig('patientStandard')" @click="navigateUrl('addition-patient');">
                <div class="iconfont icon-zengjiajiuzhenren"></div>
                <div>添加</div>
              </div>
            </template>
          </div>
          <template v-if="selectedPatient && selectedPatient.patientId">
            <template v-if="isOpenCardManage || (!isOpenCardManage && outCardSerial)">
              <template v-if="(isTodayRegister && isCardTodayRegister) || (!isTodayRegister && ((isPayCardAppointment && outCardSerial) || isCardAppointment))">
                <div class="sn-f-s-c record-line">
                  <div v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL"><span style="letter-spacing: 0.5em;">证件</span>号：</div>
                  <div v-else><span style="letter-spacing: 0.5em;">就诊</span>卡：</div>
                  <template v-if="!outCardSerial">
                    <div>{{ outCardSerialFormat }}</div>
                    <div class="sn-f-c-c sn-pointer operate" v-if="isOpenCardManage" @click="navigateUrl('addition-card');">
                      <div class="iconfont icon-zengjiajiuzhenren"></div>
                      <div>绑定</div>
                    </div>
                  </template>
                  <div v-else>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? selectedPatient.idCardEncrypt : outCardSerialFormat }}</div>
                </div>
              </template>
            </template>
          </template>
          <div class="sn-f-s-c record-line" v-if="payPattern.length > 0">
            <div>支付方式：</div>
            <div class="sn-f-s-c">
              <div class="sn-f-c-c sn-pointer pattern"
              :style="{'--background': item.background}"
              :class="{'interaction': selectedPattern === item.reg}"
              :key="item.reg" v-for="item in payPattern" @click="selectedPattern = item.reg;">
                <div class="iconfont" :class="item.icon"></div>
                <div>{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sn-prompt" v-if="promptInfo.length > 0">
          <div class="sn-prompt-title">温馨提示</div>
          <div class="sn-f-s-s sn-prompt-caption" :class="item.type === '2' ? 'sn-fc-red1 ' + item.style : item.style" :key="i" v-for="(item, i) in promptInfo">
            <div class="sn-prompt-star">★</div>
            <div v-html="item.info"></div>
          </div>
        </div>
      </div>
      <div class="sn-f-col-c-c bottom-blank">
        <div class="sn-f-c-c sn-pointer tip" @click="exhibitionTipCaption = true;">点击查看<span class="sn-fc-red1">《{{ appointmentContent }}须知》</span></div>
        <div class="sn-f-c-c sn-pointer interaction" @click="goAppointment();">{{ '确认' + appointmentContent }}</div>
      </div>
    </div>
    <div id="captcha-element"></div>
    <div id="captcha-interaction"></div>
    <pay-result v-if="exhibitionPayResult" :params="payResultParams" @sendBack="sendBackPayResult">
      <template v-slot:result>
        <div class="sn-f-col-s-c result-slot">
          <div class="sn-f-s-c result-line">
            <div><span style="letter-spacing: 0.5em;">就诊</span>人：</div>
            <div class="sn-f-1 sn-omit">{{ selectedPatient.patientName }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>
              <template v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL">
                <span style="letter-spacing: 0.5em;">证件</span>号：
              </template>
              <template v-else>
                <span style="letter-spacing: 0.5em;">就诊</span>卡：
              </template>
            </div>
            <div class="sn-f-1 sn-omit">{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? selectedPatient.idCardEncrypt : outCardSerialFormat }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>支付单号：</div>
            <div class="sn-f-1 sn-omit">{{ Object.values(payResultParams.pay)[0].serial }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>支付金额：</div>
            <div class="sn-f-1 sn-omit">{{ payResultParams.cost }}</div>
          </div>
        </div>
      </template>
    </pay-result>
    <sn-tip-caption v-if="exhibitionTipCaption" :secretary="isTodayRegister ? perpetual.SECRETARY_TYPE_TODAY_REGISTER_NOC : perpetual.SECRETARY_TYPE_APPOINTMENT_NOC" @sendBack="exhibitionTipCaption = false;"></sn-tip-caption>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import CaptchaMixin from '@/common/mixin/captcha-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';

export default {
  components: {
    'pay-result': () => import('@/components/pay-result'),
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin, CaptchaMixin, AppointmentMixin],
  data() {
    return {
      doctorInfo: {},
      scheduleInfo: {},
      scheduleTimeInfo: {},
      patientList: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      selectedPattern: '',
      isTodayRegister: false,
      isSendOutCardSerialAppointment: self.$sn.getConfig('isSendOutCardSerialAppointment'),
      isCardAppointment: self.$sn.getConfig('isCardAppointment'),
      identifyPolyScheduleRegionLogic: self.$sn.getConfig('identifyPolyScheduleRegionLogic'),
      isShowScheduleTimeSeq: self.$sn.getConfig('isShowScheduleTimeSeq'),
      isCardTodayRegister: self.$sn.getConfig('isCardTodayRegister'),
      isPayCardAppointment: self.$sn.getConfig('isPayCardAppointment'),
      //
      exhibitionTipCaption: false,
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  computed: {
    payPattern() {
      const pattern = [];
      let pay = false;
      if (this.isTodayRegister && this.$sn.getConfig('isPayTodayRegister')) pay = true;
      else if (!this.isTodayRegister) {
        if (this.$sn.getConfig('isPayAppointment')) pay = true;
        else if (this.outCardSerial && this.isPayCardAppointment) pay = true;
      }
      if (pay) {
        const compare = {
          '1': {
            'title': '支付宝',
            'icon': 'icon-alipay',
            'background': this.$sn.color.alipay
          },
          '2': {
            'title': '微信',
            'icon': 'icon-weixin2',
            'background': this.$sn.color.wechat
          }
        };
        this.$sn.getConfig('pcPayPattern').forEach(el => {
          if (!this.$sn.validate.empty(compare[el])) {
            pattern.push({
              reg: el,
              ...compare[el]
            });
          }
        });
      }
      return pattern;
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.outCardSerial = '';
      this.outCardSerialFormat = '';
      this.selectedPattern = '';
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        this.appointment_mixin_getPromptInfo({
          isToday: this.isTodayRegister ? 1 : 0,
          outCardSerial: this.outCardSerial,
          deptId: this.doctorInfo.deptId,
          hosArea: this.scheduleTimeInfo.areaId,
          doctorId: this.doctorInfo.doctorId
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.captcha_mixin_initial({
        prefix: 'ap',
        restrict: this.doctorInfo.doctorId
      });
    });
  },
  created: async function() {
    this.appointment_mixin_getSeparateCaption();
    const storage = this.$sn.utils.getHospitalSessionStorage('Appointment_SelectedScheduleTimeInfo');
    this.doctorInfo = storage.doctor;
    this.scheduleInfo = storage.schedule;
    if (this.scheduleInfo.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) this.isTodayRegister = true;
    this.scheduleTimeInfo = storage.time;
    if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL && this.scheduleTimeInfo.scheduleItemCode.indexOf('_zbmz') !== -1) {
      this.isCardAppointment = true;
    }
    else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL &&
    this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend) &&
    JSON.parse(this.doctorInfo.frontExtend).deptType === 'GJMZ') {
      this.isSendOutCardSerialAppointment = true;
      this.isCardAppointment = true;
    }
    else {
      this.isCardAppointment = this.$sn.getConfig('isCardAppointment');
    }
    if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
      if (['1526', '1526-re'].includes(this.doctorInfo.deptId) && this.doctorInfo.doctorId === '10725') {
        this.$sn.assembly.modal({
          caption: Messages.APPOINT118,
          success: (modal) => {
            if (modal.cancel) {
              this.$router.back();
            }
          }
        });
      }
    }
    else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNRM) {
      this.$sn.assembly.modal({
        caption: this.isTodayRegister ? Messages.APPOINT027 : Messages.APPOINT028,
        success: (modal) => {
          if (modal.cancel) {
            this.$router.back();
          }
        }
      });
    }
    this.handlePatientInfo();
  },
  methods: {
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.patientList && this.patientList.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    goAppointment(value) {
      if (this.isTodayRegister &&
      (this.$sn.utils.getHospitalId() !== this.perpetual.HOSPITAL_ID_JNRM || this.scheduleTimeInfo.areaId !== '1' || this.doctorInfo.deptId !== '发热专业')) {
        if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') >= this.$sn.getConfig('eveningTodayRegisterEndTime')) {
          this.$sn.assembly.modal({
            caption: Messages.APPOINT001,
            isCancel: false
          });
          return false;
        }
        if (this.$sn.getConfig('isTodayRegisterRealTime')) {
          const time = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss');
          const afternoon = this.$sn.getConfig('afternoonTodayRegisterStartTime');
          const dawn = this.$sn.getConfig('dawnTodayRegisterStartTime');
          if (time >= this.$sn.getConfig('morningTodayRegisterEndTime') && time < afternoon) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.APPOINT004, [afternoon.substring(0, 2), afternoon.substring(2, 4)]),
              isCancel: false
            });
            return false;
          }
          if (time < dawn) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.APPOINT005, [dawn.substring(0, 2), dawn.substring(2, 4)]),
              isCancel: false
            });
            return false;
          }
        }
      }
      let pay = '0';
      if (this.isTodayRegister && this.scheduleInfo.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') && this.$sn.getConfig('isPayTodayRegister')) {
        pay = '1';
      }
      else if (!this.isTodayRegister && this.$sn.getConfig('isPayAppointment')) {
        pay = '1';
      }
      else if (!this.isTodayRegister && this.outCardSerial && this.isPayCardAppointment) {
        pay = '1';
      }
      if (this.$sn.validate.empty(this.selectedPatient) || this.$sn.validate.empty(this.selectedPatient.patientId)) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT016,
          success: (modal) => {
            if (modal.confirm) {
              this.navigateUrl('addition-patient');
            }
          }
        });
        return false;
      }
      if (this.selectedPatient.idCardType === '0' && this.selectedPatient.isChildren !== '2') {
        if (!this.$sn.validate.idCardSerial(this.selectedPatient.patientIdCardNo)) {
          this.$sn.assembly.modal({
            caption: Messages.PATIENT006,
            success: (modal) => {
              if (modal.confirm) {
                // TODO
              }
            }
          });
          return false;
        }
      }
      if (this.$sn.validate.empty(this.outCardSerial)) {
        if ((this.isTodayRegister && this.isCardTodayRegister) || (!this.isTodayRegister && this.isCardAppointment)) {
          let caption = '';
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL && this.scheduleTimeInfo.scheduleItemCode.indexOf('_zbmz') !== -1) {
            caption = 'PATIENT018';
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
            caption = 'PATIENT042';
          }
          else {
            caption = this.isOpenCardManage ? 'PATIENT017' : 'APPOINT109';
          }
          this.$sn.assembly.modal({
            caption: Messages[caption],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
          return false;
        }
      }
      if (this.payPattern.length > 0 && this.$sn.validate.empty(this.selectedPattern)) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.C019, ['支付方式']),
          isCancel: false
        });
        return false;
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
        if (this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend)) {
          if (this.isTodayRegister && JSON.parse(this.doctorInfo.frontExtend).notReserve === '1') {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT085,
              isCancel: false
            });
            return false;
          }
        }
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
        if (this.$sn.validate.empty(value)) {
          if (this.doctorInfo.deptId === '1200') {
            if (!this.selectedPatient.patientIdCardNo ||
            (this.selectedPatient.patientIdCardNo && this.$sn.format.ageByBirthday(this.$sn.format.birthdayByIdCardSerial(this.selectedPatient.patientIdCardNo)) >= 17)) {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.APPOINT030, [17, this.doctorInfo.deptName]),
                success: (modal) => {
                  if (modal.confirm) {
                    this.goAppointment('value');
                  }
                }
              });
              return false;
            }
          }
          else if (this.scheduleTimeInfo.doctor.deptId === '1310') {
            if (!this.selectedPatient.patientIdCardNo ||
            (this.selectedPatient.patientIdCardNo && this.$sn.format.ageByBirthday(this.$sn.format.birthdayByIdCardSerial(this.selectedPatient.patientIdCardNo)) >= 14)) {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.APPOINT030, [14, this.scheduleTimeInfo.doctor.deptName]),
                success: (modal) => {
                  if (modal.confirm) {
                    this.goAppointment('value');
                  }
                }
              });
              return false;
            }
          }
        }
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_TAFY) {
        if (this.$sn.validate.empty(value)) {
          this.$sn.assembly.modal({
            caption: Messages.APPOINT031,
            success: (modal) => {
              if (modal.confirm) {
                this.goAppointment('value');
              }
            }
          });
          return false;
        }
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNFY) {
        if (this.$sn.validate.empty(value)) {
          if (this.doctorInfo.deptId === 'ZS0209') {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT033,
              success: (modal) => {
                if (modal.confirm) {
                  this.goAppointment('value');
                }
              }
            });
            return false;
          }
        }
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
        if (this.$sn.validate.empty(value)) {
          if (this.scheduleTimeInfo.scheduleItemCode.indexOf('_hjbmz') !== -1) {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT069,
              success: (modal) => {
                if (modal.confirm) {
                  this.goAppointment('value');
                }
              }
            });
            return false;
          }
        }
      }
      if ((this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSJSWSZX && this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend) && JSON.parse(this.doctorInfo.frontExtend).isTreatment) ||
      (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY && parseFloat(this.scheduleInfo.serviceFee) > 0)) {
        if (this.$sn.validate.empty(value)) {
          this.$sn.assembly.modal({
            title: '通知',
            caption: Messages.APPOINT036,
            success: (modal) => {
              if (modal.confirm) {
                this.goAppointment('value');
              }
            }
          });
          return false;
        }
      }
      if ([this.perpetual.HOSPITAL_ID_SLX, this.perpetual.HOSPITAL_ID_EBH].includes(this.$sn.utils.getHospitalId())) {
        if (this.$sn.validate.empty(value)) {
          let finale = this.$sn.format.date(new Date(this.scheduleInfo.scheduleDate), 'yyyy年MM月dd日') + this.scheduleTimeInfo.startTime.substring(0, 5);
          if (this.scheduleTimeInfo.endTime) {
            finale += '-' + this.scheduleTimeInfo.endTime.substring(0, 5);
          }
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(Messages.APPOINT081, [this.doctorInfo.deptName, this.doctorInfo.doctorName, finale]),
            success: (modal) => {
              if (modal.confirm) {
                this.goAppointment('value');
              }
            }
          });
          return false;
        }
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNYZ) {
        if (this.$sn.validate.empty(value)) {
          this.$sn.assembly.modal({
            caption: Messages.APPOINT092,
            success: (modal) => {
              if (modal.confirm) {
                this.goAppointment('value');
              }
            }
          });
          return false;
        }
      }
      if (this.isTodayRegister && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('dawnTodayRegisterStartTime')) {
        if (this.$sn.utils.getHospitalSessionStorage('Appointment_SelectedSecondaryDepartInfo') && this.$sn.utils.getHospitalSessionStorage('Appointment_SelectedSecondaryDepartInfo').remark === '1' && this.$sn.getConfig('isTodayRegisterEmergencyEntireDay')) {
          if ((this.isTodayRegister && this.$sn.getConfig('isOpenOptPayConditionTodayRegister')) || (!this.isTodayRegister && this.$sn.getConfig('isOpenOptPayConditionAppointment'))) {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT037,
              captionConfirm: '是',
              captionCancel: '否',
              success: (modal) => {
                pay = modal.confirm ? '1' : '0';
                this.createAppointment(pay);
              }
            });
            return false;
          }
          this.createAppointment(pay);
        }
        else {
          const startTime = this.$sn.getConfig('dawnTodayRegisterStartTime').substring(0, 2) + ':' + this.$sn.getConfig('dawnTodayRegisterStartTime').substring(2, 4);
          const endTime = this.$sn.getConfig('eveningTodayRegisterEndTime').substring(0, 2) + ':' + this.$sn.getConfig('eveningTodayRegisterEndTime').substring(2, 4);
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(Messages.APPOINT038, [startTime, endTime]),
            isCancel: false
          });
        }
        return false;
      }
      if ((this.isTodayRegister && this.$sn.getConfig('isOpenOptPayConditionTodayRegister')) || (!this.isTodayRegister && this.$sn.getConfig('isOpenOptPayConditionAppointment'))) {
        this.$sn.assembly.modal({
          caption: Messages.APPOINT037,
          captionConfirm: '是',
          captionCancel: '否',
          success: (modal) => {
            pay = modal.confirm ? '1' : '0';
            this.createAppointment(pay);
          }
        });
        return false;
      }
      this.createAppointment(pay);
    },
    sendBackCaptcha(result, business) {
      const {
        pay,
        pattern
      } = business;
      if (result) {
        if (result.code === 0) {
          this.suffix(result.data, pay, pattern);
        }
        else {
          this.$sn.assembly.loading(false);
          // 就诊卡余额不足
          if (pay === '1' && pattern === this.perpetual.DICT_PAY_MODE_CARD && result.msg.indexOf(Messages.RECHARGE001) !== -1) {
            // TODO
            return false;
          }
          this.$sn.assembly.modal({
            caption: result.msg,
            isCancel: false
          });
        }
      }
      else {
        this.$sn.assembly.loading(false);
        this.$sn.assembly.modal({
          caption: Messages.C001,
          isCancel: false
        });
      }
    },
    async createAppointment(pay, pattern) {
      const getBalance = () => {
        return new Promise(resolve => {
          const params = {
            url: Swagger.getCardBalance,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              bindType: this.$sn.utils.getPlatformType(),
              cardNo: this.outCardSerial,
              clinicType: this.perpetual.OUT_CARD_CLINIC_TYPE,
              hosArea: '',
              hosId: this.$sn.utils.getHospitalId(),
              idCardNo: '',
              openId: this.$sn.utils.getOpenId(),
              patName: '',
              patientId: this.selectedPatient.patientId,
              reservedDate: '',
              state: ''
            })
          };
          this.$sn.utils.ordinaryRequest(params).then(result => {
            const fructify = {
              code: 0,
              msg: '',
              data: {}
            };
            if (result) {
              if (result.code === 0 && result.data && result.data.cardBalance) {
                fructify.data = result.data;
              }
              else {
                fructify.code = 2;
                fructify.msg = Messages.RECHARGE010;
              }
            }
            else {
              fructify.code = 1;
              fructify.msg = Messages.C001;
            }
            resolve(fructify);
          });
        });
      };
      // 多支付方式供用户选择前置处理
      /* eslint-disable */
      let dict = [];
      let gather = []; // 支付方式集合
      let balance = {}; // 就诊卡余额
      let fee = {}; // 核准挂号费
      /* eslint-enable */
      if (pay === '1') {
        dict = await Tools.dict([this.perpetual.DICTIONARY_CODE_PAY_MODE]);
        gather = this.isTodayRegister ? this.$sn.getConfig('payPatternTodayRegister').split(',') : this.$sn.getConfig('payPatternAppointment').split(',');
        if (!this.$sn.validate.empty(gather.find(result => result === this.perpetual.DICT_PAY_MODE_CARD))) {
          this.$sn.assembly.loading(true);
          balance = await getBalance();
          fee = await this.appointment_mixin_cost({
            regFee: this.selectedCost,
            patientId: this.selectedPatient.patientId,
            schId: this.selectedItem.scheduleItemCode
          });
          this.$sn.assembly.loading(false);
          if (!this.$u.getProperty(fee, 'data.regFee')) {
            this.$sn.assembly.modal({
              caption: fee.msg,
              isCancel: false
            });
            return false;
          }
        }
        if (gather.length > 0) {
          // 如当前仅有一个支付方式，则直接使用
          if (gather.length === 1) pattern = gather[0];
          // 如当前仍为选择支付方式，则指引用户选择支付方式
          if (!pattern) {
            // TODO
            return false;
          }
          // 就诊卡支付前置处理
          if (pattern === this.perpetual.DICT_PAY_MODE_CARD) {
          }
          // 自费支付前置处理
          else if (pattern === this.perpetual.DICT_PAY_MODE_SELF) {
            const startMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeEndTime') + ':00';
            const startMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd', 1, 'day') + ' 00:00:00';
            const endMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' 00:00:00';
            const endMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeStartTime') + ':00';
            const current = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd HH:mm:ss');
            if (this.$sn.validate.range(current, [startMinDate, startMaxDate]) || this.$sn.validate.range(current, [endMinDate, endMaxDate])) {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.APPOINT029,
                  [this.appointmentContent, this.$sn.getConfig('rechargeStartTime'), this.$sn.getConfig('rechargeEndTime')]),
                isCancel: false
              });
              return false;
            }
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(Messages.C018, ['支付方式']),
            isCancel: false
          });
          return false;
        }
      }
      // ----- START ----- 就诊卡相关参数前置处理 ----- START -----
      let isCard = '0';
      let serial = '';
      if ((this.isTodayRegister && this.isCardTodayRegister) || (!this.isTodayRegister && this.isCardAppointment)) {
        isCard = '1';
        serial = this.outCardSerial;
      }
      // ----- END ----- 就诊卡相关参数前置处理 ----- END -----
      const params = {
        url: Swagger.createAppointment,
        method: 'POST',
        header: true,
        data: {
          appType: '',
          authcode: '',
          businessType: this.scheduleTimeInfo.businessType,
          cardNo: serial,
          deptId: this.scheduleInfo.deptId,
          firstDiagnosis: '',
          firstDoctor: '',
          firstTime: '',
          hasCard: isCard,
          hosId: this.$sn.utils.getHospitalId(),
          isDopay: pay,
          mchid: '',
          medicalInsuranceFlag: '0',
          patId: this.selectedPatient.patientId,
          patientIdCardNo: this.selectedPatient.patientIdCardNo,
          payWay: '',
          productType: '',
          projectType: this.$sn.utils.getProjectType(),
          regType: this.$sn.utils.getRegType() || this.selectedPattern || this.perpetual.REG_TYPE_OTHER,
          schId: this.scheduleTimeInfo.scheduleItemCode,
          schTime: this.scheduleTimeInfo.timeId,
          thRegId: '',
          type: this.$sn.utils.getPlatformType(),
          userId: this.$sn.utils.getOpenId()
        }
      };
      if (this.captcha_mixin_verify({
        prefix: 'ap',
        restrict: this.doctorInfo.doctorId
      })) {
        this.captchaBiz = {
          params,
          cb: this.sendBackCaptcha,
          business: {
            pay,
            pattern
          }
        };
        this.captcha_mixin_exhibition();
        return false;
      }
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        ...params,
        data: JSON.stringify(params.data)
      }).then(result => {
        this.sendBackCaptcha(result, {
          pay,
          pattern
        });
      });
    },
    suffix(result, pay, pattern) {
      this.$sn.utils.setHospitalLocalStorage('Appointment_CompleteInfo', result);
      // 用于处理中间件返回当前已进行挂号费支付的场景
      if (pay === '1' && result.isDopay === 1) {
        pattern = '';
      }
      // 无其它逻辑，直接预约成功
      if (this.$sn.validate.empty(pattern)) {
        this.$sn.assembly.loading(false);
        let caption = Messages.C016;
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNSJGYY) {
          caption += Messages.APPOINT073;
        }
        if (this.$sn.getConfig('appointmentResultTip') === '2') {
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(caption, [this.appointmentContent]),
            isCancel: false,
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('/appointment/complete', '', {}, 'replace');
              }
            }
          });
        }
        else {
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(caption, [this.appointmentContent]),
            mode: 'success',
            success: () => {
              this.navigateUrl('/appointment/complete', '', {}, 'replace');
            }
          });
        }
      }
      // 就诊卡支付
      else if (pattern === this.perpetual.DICT_PAY_MODE_CARD) {
        this.appointment_mixin_card(result, this.selectedPatient, this.selectedPattern);
      }
      // 自费支付
      else if (pattern === this.perpetual.DICT_PAY_MODE_SELF) {
        this.appointment_mixin_platform(result, this.selectedPatient, this.selectedPattern);
      }
    },
    sendBackPatient(id) {
      if (id) {
        this.selectedPatient = this.patientList.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    sendBackPayResult(type, status) {
      if (!type) {
        const record = this.$sn.utils.getHospitalLocalStorage('Appointment_CompleteInfo');
        if (record.state === 1 || status === 1) this.navigateUrl('/appointment/record', '', {}, 'replace');
      }
      this.homepage_mixin_sendBackPayResult(type);
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params = {}, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else {
        this.appointment_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.confirm {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    width: 100%;
    padding: 20px;

    .entire {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;

      .doctor {
        width: 100%;
        height: 160px;
        margin: 20px 0;

        .sn-head-photo {
          margin-right: 10px;
        }

        &-info {
          height: 160px;

          .doctor-sub {
            @include fs(14);

            height: 100%;
            border-left: 1px solid $main3;
            padding-left: 10px;
            margin-left: 10px;
          }

          .doctor-caption {
            @include fs(14);

            overflow-x: hidden;
            overflow-y: auto;
            width: 100%;
            margin-top: 10px;

            div {
              margin-bottom: 10px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .record {
        overflow: hidden;
        width: 100%;
        padding: 20px 0;

        &-line {
          @include fs(16);

          overflow: hidden;
          width: 100%;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }

          .operate {
            color: $main3;
            border: 1px solid $main3;
            border-radius: 4px;
            padding: 0 10px;
            margin-left: 20px;

            .iconfont {
              font-size: 12px;
              color: $main3;
              margin-right: 4px;
            }
          }

          .pattern {
            width: 160px;
            height: 40px;
            color: $text1;
            border: 1px solid $border1;
            border-radius: 4px;
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }

            &.interaction {
              background-color: var(--background);
              color: $white;
              border: none;

              .iconfont {
                color: $white;
              }
            }

            .iconfont {
              font-size: 18px;
              color: $text1;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .bottom-blank {
      overflow: hidden;
      width: 100%;
      padding-top: 20px;

      .tip {
        @include fs(16);

        overflow: hidden;
        width: 100%;
        color: $text1;
        margin-bottom: 10px;
      }

      .interaction {
        @include fs(14);

        overflow: hidden;
        width: 200px;
        height: 40px;
        background-color: $main3;
        color: $white;
        border-radius: 5px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
